/* eslint-disable */
export default {
    
    finalize() {
      
      const inputs = Array.from(document.querySelectorAll('.wpcf7-form-control'));
      
      if (inputs) {
        inputs.forEach(input => {
          input.addEventListener('focus', () => {
            input.labels[0].classList.add('availability-form__label--active');
          })
          input.addEventListener('blur', () => {
            if (!input.value) {
              input.labels[0].classList.remove('availability-form__label--active');
            }
          })
        })
      }

      const form = document.querySelector('.wpcf7');

      if (form) {
        form.addEventListener('wpcf7mailsent', () => {
          inputs.forEach(input => {
            input.labels[0].classList.remove('availability-form__label--active');
          })
        })
      }

      const houseNameInput = document.querySelector('#avform-house-name');
      const houseLinkInput = document.querySelector('#avform-house-link');
      const houseName = document.querySelector('#page-header__title');

      if (houseLinkInput && houseNameInput) {
        houseLinkInput.value = window.location.href;
        houseNameInput.value = houseName ? houseName.innerText : '';
      }

    },
  };


// WEBPACK FOOTER //
// ./scripts/routes/singleHouse.js